export const DEFAULT_APPROVAL_DAYS = "30";

const ACTION_LABELS = {
  GMAIL_SEND_EMAIL: "Send an email with Gmail",
};

export function actionLabel(card) {
  const action = card.tool_slug || card.action_type || "Connected-app action";
  return (
    ACTION_LABELS[action] ||
    action
      .replaceAll("_", " ")
      .toLowerCase()
      .replace(/^./, (letter) => letter.toUpperCase())
  );
}

export function fixedRecipient(card) {
  const principal = card.principal || card.allowed_inputs?.principal || {};
  const value = principal.recipient_email || principal.to || principal.email;
  return typeof value === "string" && !value.startsWith("$ref") ? value : null;
}

export function attachmentLabel(card) {
  const reference = card.review?.attachment_source;
  if (!reference) return null;
  const artifactName = reference.split(".").at(-1)?.replaceAll("_", " ");
  return artifactName
    ? `Attach ${artifactName.replace(/\bai\b/i, "AI")}`
    : "Attach the generated report";
}

export function approvalError(error) {
  return (
    error?.response?.data?.detail ||
    error?.message ||
    "Could not activate this automation. Please try again."
  );
}
